import axiosInstance from "../axiosInstance";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
export const fetchNotifications = createAsyncThunk(
  "fetch/notifications",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("notificationList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const addNotifications = createAsyncThunk(
  "add/notifications",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("addNotification", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const editNotifications = createAsyncThunk(
  "edit/notifications",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("editNotification", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const deleteNotifications = createAsyncThunk(
  "delete/notifications",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete("deleteNotification", {
        data: payload,
      });
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const resendNotifications = createAsyncThunk(
  "delete/notifications",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("resendNotification", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    notifications: [],
    isFetching: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchNotifications.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(fetchNotifications.fulfilled, (state, action) => {
      state.isFetching = false;
      state.notifications = action.payload;
    });
    builder.addCase(fetchNotifications.rejected, (state, action) => {
      state.isFetching = false;
      state.error = action.error.message;
    });
  },
});

export default notificationSlice.reducer;
